import { HealthDeclarationPage } from '@pages/HealthDeclarationPage'
import { HomePage } from '@pages/HomePage/HomePage'
import LoginPage from '@pages/LoginPage/LoginPage'
import MakeAppointmentPage from '@pages/MakeAppointmentPage'
import MyBookingsPage from '@pages/MyBookingsPage'
import type { TFunction } from 'i18next'
import { createBrowserRouter } from 'react-router-dom'

import CalendarBoxIcon from '@/assets/icons/calendar-box-icon.svg?react'
import ChatIcon from '@/assets/icons/chat-icon.svg?react'
import ClockIcon from '@/assets/icons/clock-icon.svg?react'
import InboxIcon from '@/assets/icons/inbox-icon.svg?react'
import ProfileIcon from '@/assets/icons/profile-icon.svg?react'
import type { MenuItemProps } from '@/components/MenuIList'

import App from './App'
import HubPanel from './HubPanel'
import { RouterPath } from './models/enums'

export const headerSidebarLinks = (t: TFunction<'menu', undefined>): MenuItemProps[] => [
  {
    children: t('home'),
    icon: <InboxIcon />,
    to: RouterPath.Home,
  },
  {
    children: t('my_bookings'),
    icon: <CalendarBoxIcon />,
    to: RouterPath.MyBookings,
  },
  {
    children: t('make_appointment'),
    icon: <ClockIcon />,
    to: RouterPath.MakeAppointment,
  },
]

export const footerSidebarLinks = (t: TFunction<'menu', undefined>): MenuItemProps[] => [
  {
    children: t('my_profile'),
    icon: <ProfileIcon />,
    to: RouterPath.MyProfile,
  },
  {
    children: t('help'),
    icon: <ChatIcon />,
    to: RouterPath.Help,
  },
]

export const router = createBrowserRouter([
  {
    path: RouterPath.Root,
    element: <App />,
    children: [
      {
        path: RouterPath.Hub,
        element: <HubPanel />,
        children: [
          {
            path: RouterPath.Home,
            element: <HomePage />,
          },
          {
            path: RouterPath.MakeAppointment,
            element: <MakeAppointmentPage />,
          },
          {
            path: RouterPath.MyBookings,
            element: <MyBookingsPage />,
          },
          {
            path: RouterPath.HealthDeclaration,
            element: <HealthDeclarationPage />,
          },
        ],
      },
      {
        path: RouterPath.Login,
        element: <LoginPage />,
      },
    ],
  },
])
